import React from 'react'
import headerimg from '../assets/OWRB header.png'
import "../assets/Pages.css"

export default function ContactUs() {
    return (
        <div>

            <main className="flex-shrink-0 modular min-vh-100 mt-5">

                <img className='my-5' style={{ maxWidth: "100%" }} src={headerimg} />

                <div className="container mt-2">
                    <div className='row'>
                        <div className='col-1 d-none d-lg-block'></div>
                        <div className='col-12 col-lg-10'>
                            <div className="row">
                                <div className="col" style={{ textAlign: "start" }}>
                                    <h1>Contact Us</h1>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col" style={{ textAlign: "start" }}>
                                    <p>For more information, please contact:</p>
                                    <p>
                                        <b>Yohanes Sugeng, PE, CFM</b> | <b>Dam Safety | Engineering Manager</b>
                                        <br /><a href="mailto:yohanes.sugeng@owrb.ok.gov">yohanes.sugeng@owrb.ok.gov</a>
                                    </p>
                                    <p>
                                        <b>Aaron Milligan</b> | <b>Environmental Programs Manager Floodplain Management</b>
                                        <br /><a href="mailto:aaron.milligan@owrb.ok.gov">aaron.milligan@owrb.ok.gov</a>
                                    </p>
                                    <p>
                                        <b>OKLAHOMA WATER RESOURCES BOARD</b>
                                        <br />3800 North Classen Blvd., Oklahoma City, OK 73118
                                        <br /><a href="+14055308800">405.530.8800</a> • <a href="https://www.owrb.ok.gov/" target="_blank">owrb.ok.gov</a> • <a href="https://www.facebook.com/okwaterboard/" target="_blank">Facebook</a> • <a href="https://twitter.com/OKWaterBoard" target="_blank">Twitter</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className='col-1'></div>
                    </div>
                </div>

            </main>

        </div>
    )
}

